import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGoodsActivityList, goodsActivityCreate, goodsActivityUpdate, deleteGoodsActivity, goodsActivityStatus, getSellerList } from '@/api/bairun/bianlidian'; //  此处请自行替换地址

import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import GoodsSelectComponent from '@/view/bianlidianManage/goods/goodsSelectComponent';

var _this;

export default {
  name: 'PointShopConfig',
  components: {
    GoodsSelectComponent: GoodsSelectComponent
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerName: function getSellerName(id) {
      debugger;

      for (var i = 0; i < _this.sellerOptions.length; i++) {
        if (_this.sellerOptions[i].sellerId == id) {
          return _this.sellerOptions[i].sellerName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getGoodsActivityList,
      type: '',
      sellerOptions: [],
      multipleSelection: [],
      addPointGoodsDialogVisible: false,
      viewPointGoodsDialogVisible: false,
      dialogTitle: '',
      goodsComponentFormData: {
        goodsType: '',
        dialogVisible: false,
        sellerId: '',
        selection: [],
        // 回显，如果有数据，组件默认勾选
        activityGoodsMoney: '0'
      },
      formData: {},
      publicRules: {
        sellerId: [{
          required: true,
          message: '请选择商店',
          trigger: 'blur'
        }],
        activityName: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        isAllGoods: [{
          required: true,
          message: '请选择商品',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    getRule: function getRule() {
      return this.publicRules;
    }
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var sellerOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log('PointShopConfig init');

                if (!_this) {
                  // keepAlive=true beforeCreate不执行
                  _this = _this3;
                }

                _context3.next = 4;
                return getSellerList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 4:
                sellerOptions = _context3.sent;
                _this3.sellerOptions = sellerOptions.data.list;
                _this3.formData = _this3.initData();
                _this3.searchInfo.shopActivityType = _this3.formData.shopActivityType;

                _this3.getTableData();

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        sellerId: '',
        sellerName: '',
        activityName: '',
        ruleType: 5,
        ruleTypeSub: 2,
        startTime: '2022-01-01 00:00:00',
        endtime: '2099-01-01 00:00:00',
        isAllGoods: 2,
        ruleRemark: '',
        goodsNo: '',
        moneySource: 1,
        // 写死
        discountLevel: 2,
        // 写死
        shopActivityType: 3,
        // 写死
        activityRuleSingle: [this.initActivityRuleSingle()],
        activityRuleList: [this.initActivityRuleSingle()],
        activityGoodsList: [] // 活动商品

      };
      return formdata;
    },
    initActivityRuleSingle: function initActivityRuleSingle() {
      return {
        limits: '',
        discount: '',
        discountMax: '',
        extraAddmoney: '',
        onePrice: ''
      };
    },
    // 条件搜索前端看此方法
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.searchInfo.shopActivityType = this.formData.shopActivityType;
      this.getTableData();
    },
    onReset: function onReset() {
      this.searchInfo = {
        shopActivityType: this.formData.shopActivityType
      };
      this.onSubmit();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    // 选择商品-确定
    goodsSelDialogOk: function goodsSelDialogOk(res) {
      var that = this;
      that.goodsComponentFormData.dialogVisible = false;

      if (res && res.length > 0) {
        res.forEach(function (item) {
          item.goodsNum = 1;

          if (that.goodsComponentFormData.goodsType == 'pointGoods') {
            var isExit = false;
            that.formData.activityGoodsList.forEach(function (item2) {
              if (item2.spuNo === item.spuNo) {
                isExit = true;
              }
            });

            if (!isExit) {
              that.formData.activityGoodsList.push(JSON.parse(JSON.stringify(item)));
            }
          }
        });
      }

      if (that.formData.activityGoodsList.length === 1) {
        that.formData.activityName = that.formData.activityGoodsList[0].goodsName;
      } else {
        that.formData.activityName = '';
      }

      that.computeGoodsPrice();
      that.$forceUpdate();
    },
    // 计算商品原价
    computeGoodsPrice: function computeGoodsPrice() {
      var that = this;

      if (that.formData.activityGoodsList) {
        var goodsPrice = 0;
        that.formData.activityGoodsList.forEach(function (item) {
          goodsPrice = goodsPrice + parseFloat(item.goodsPrice) * (item.goodsNum && parseFloat(item.goodsNum) > 0 ? parseFloat(item.goodsNum) : 1);
        });
        that.goodsComponentFormData.activityGoodsMoney = goodsPrice.toFixed(2);
      } else {
        that.goodsComponentFormData.activityGoodsMoney = 0;
      }
    },
    // 选择商品-关闭
    goodsSelDialogClose: function goodsSelDialogClose() {
      this.goodsComponentFormData.dialogVisible = false;
    },
    onRowdbclick: function onRowdbclick(row) {
      this.onView(row);
    },
    // 添加
    onAdd: function onAdd() {
      this.type = 'addPointGoods';
      this.addPointGoodsDialogVisible = true;
      this.dialogTitle = '新增兑换商品';
    },
    onView: function onView(row) {
      this.type = 'viewPointGoods';
      this.dialogTitle = '查看兑换商品';
      this.viewPointGoodsDialogVisible = true;
      this.handleViewOrUpdate(row);
    },
    onUpdate: function onUpdate(row) {
      this.type = 'updatePointGoods';
      this.addPointGoodsDialogVisible = true;
      this.dialogTitle = '变更兑换商品';
      this.handleViewOrUpdate(row);
      this.$forceUpdate();
    },
    handleViewOrUpdate: function handleViewOrUpdate(row) {
      var that = this;
      row.activityRuleSingle = [];
      that.formData = JSON.parse(JSON.stringify(row));

      if (row.activityRuleList && row.activityRuleList.length > 0) {
        that.formData.activityRuleSingle.push(JSON.parse(JSON.stringify(row.activityRuleList[0])));
      }

      if (that.formData.activityGoodsList && that.formData.activityGoodsList.length > 0) {
        var activityGoodsList = []; // 活动商品

        that.formData.activityGoodsList.forEach(function (item) {
          if (item.activityGoodsType == 0) {
            // 活动商品
            activityGoodsList.push(item);
          }
        });
        that.formData.activityGoodsList = activityGoodsList;
      }

      if (!that.formData.activityGoodsList) {
        that.formData.activityGoodsList = []; // 活动商品，初始化以便修改时有该对象
      }

      that.computeGoodsPrice();
      that.formData.sellerName = that.$options.filters.getSellerName(row.sellerId);
      that.formData.startTime = that.$options.filters.formatDate(row.startTime);
      that.formData.endTime = that.$options.filters.formatDate(row.endTime);
    },
    onAble: function onAble(row) {
      var that = this;
      goodsActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 1
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    onDisable: function onDisable(row) {
      var that = this;
      goodsActivityStatus({
        'activityNo': row.activityNo,
        'activityStatus': 2
      }).then(function (res) {
        if (res.code == 0) {
          that.$message({
            type: 'success',
            message: res.msg
          });
          that.enterDialogRepose(res);
        }
      }, function (error) {});
    },
    onDelete: function onDelete(row) {
      var that = this;
      that.$confirm('确定要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        deleteGoodsActivity({
          'activityNo': row.activityNo,
          'sellerId': row.sellerId
        }).then(function (res) {
          if (res.code == 0) {
            that.$message({
              type: 'success',
              message: res.msg
            });
            that.enterDialogRepose(res);
          }
        }, function (error) {});
      }).catch(function (err) {});
    },
    // 选择便利店
    onSellerChange: function onSellerChange() {
      var that = this; // eslint-disable-next-line eqeqeq

      if (that.formData.sellerId != that.goodsComponentFormData.sellerId) {
        that.formData.activityGoodsList = [];
        that.goodsComponentFormData.activityGoodsMoney = 0;
      }

      this.$forceUpdate();
    },
    // 阶梯规则添加
    onAddRule: function onAddRule(index) {
      var that = this;
      that.formData.activityRuleList.splice(index + 1, 0, that.initActivityRuleSingle());
    },
    // 阶梯规则删除
    onDeleteRule: function onDeleteRule(index) {
      var that = this;

      if (that.formData.activityRuleList.length == 1) {
        return;
      }

      that.formData.activityRuleList.splice(index, 1);
    },
    // 添加商品
    onAddGoods: function onAddGoods(goodsType) {
      var that = this;

      if (!that.formData.sellerId || that.formData.sellerId === '') {
        that.$message({
          type: 'warning',
          message: '请选择便利店'
        });
        return;
      }

      that.goodsComponentFormData.dialogVisible = true;
      that.goodsComponentFormData.sellerId = that.formData.sellerId;
      that.goodsComponentFormData.goodsType = goodsType;
    },
    // 删除活动商品
    onDelActivityGoods: function onDelActivityGoods(row) {
      var that = this; // eslint-disable-next-line eqeqeq

      that.formData.activityGoodsList = that.formData.activityGoodsList.filter(function (item) {
        return item.ID != row.ID;
      });

      if (that.formData.activityGoodsList.length === 1) {
        that.formData.activityName = that.formData.activityGoodsList[0].goodsName;
      } else {
        that.formData.activityName = '';
      }

      that.computeGoodsPrice();
      that.$forceUpdate();
    },
    closeDialog: function closeDialog() {
      this.addPointGoodsDialogVisible = false;
      this.viewPointGoodsDialogVisible = false;
      this.type = '';
      this.dialogTitle = '';
      this.goodsComponentFormData = {
        dialogVisible: false,
        sellerId: '',
        selection: [],
        goodsType: '',
        activityGoodsMoney: '0'
      };
      this.formData = this.initData();
      this.$forceUpdate();
    },
    onDialogSubmit: function onDialogSubmit() {
      var that = this;

      switch (that.type) {
        case 'addPointGoods':
          that.handleAdd('onePriceFormData');
          break;

        case 'updatePointGoods':
          that.handleUpdate('onePriceFormData');
          break;

        default:
          break;
      }
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.closeDialog();
        this.getTableData();
      }
    },
    // 新增保存
    handleAdd: function handleAdd(refFormData) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var that;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                that = _this4;
                that.$refs[refFormData].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    goodsActivityCreate(that.getParam()).then(function (res) {
                      if (res.code == 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    // 变更保存
    handleUpdate: function handleUpdate(refFormData) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var that;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                that = _this5;
                that.$refs[refFormData].validate(function (valid) {
                  if (valid && that.validFormData()) {
                    goodsActivityUpdate(that.getParam()).then(function (res) {
                      if (res.code === 0) {
                        that.$message({
                          type: 'success',
                          message: res.msg
                        });
                        that.enterDialogRepose(res);
                      }
                    }, function (error) {});
                  }
                });

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    // 公共校验函数
    validFormData: function validFormData() {
      var that = this;

      if (that.formData.activityGoodsList.length == 0) {
        that.$message({
          type: 'warning',
          message: '请选择活动商品'
        });
        return false;
      }

      return true;
    },
    getParam: function getParam() {
      var that = this;
      var formData = JSON.parse(JSON.stringify(that.formData)); // 规则

      if (that.formData.activityRuleList && that.formData.activityRuleList.length > 0) {
        formData.activityRuleList.forEach(function (item) {
          item.activityNo = that.formData.activityNo;
        });
      } // 活动商品


      var activityGoodsList = [];

      if (formData.activityGoodsList && formData.activityGoodsList.length > 0) {
        formData.activityGoodsList.forEach(function (item) {
          item.activityGoodsType = 0;
          item.activityNo = that.formData.activityNo;
          delete item['ID'];
          activityGoodsList.push(item);
        });
      }

      delete formData['activityRuleSingle'];
      formData.activityGoodsList = activityGoodsList;
      return formData;
    }
  }
};